type CalendarCriteria = {
  filter?: {
    category?: { ids: number[] };
    location?: { country?: { ids: number[] } };
    instrument?: { ids: number[] };
  };
};

export type CalendarCriteriaInput = {
  categoryIds?: number[];
  countryIds?: number[];
  identifiers?: string[];
};

export function buildCalendarCriteria({
  categoryIds,
  countryIds,
  identifiers,
}: CalendarCriteriaInput): CalendarCriteria {
  const criteriaItem: CalendarCriteria = {};

  if (categoryIds && categoryIds.length > 0) {
    criteriaItem.filter = {
      ...criteriaItem.filter,
      category: { ids: categoryIds },
    };
  }

  if (countryIds && countryIds.length > 0) {
    criteriaItem.filter = {
      ...criteriaItem.filter,
      location: { country: { ids: countryIds } },
    };
  }

  if (identifiers && identifiers.length > 0) {
    criteriaItem.filter = {
      ...criteriaItem.filter,
      instrument: { ids: identifiers.map((x) => Number.parseInt(x)) },
    };
  }

  return criteriaItem;
}

type NewsCriteria = {
  criteria: Array<{
    categories?: { ids: number[] };
    distributor?: { ids: number[] };
    instruments?: { ids: string[] };
    markets?: { restrict?: { ids: number[] } };
  }>;
};

export type NewsCriteriaInput = {
  categoriesIds?: number[];
  distributorIds?: number[];
  identifiers?: string[];
};
type NewsCriteriaItem = NewsCriteria["criteria"][0];
export function buildNewsCriteria({
  categoriesIds,
  distributorIds,
  identifiers,
}: NewsCriteriaInput): NewsCriteria {
  const criteriaItem: NewsCriteriaItem = {};

  if (categoriesIds && categoriesIds.length > 0) {
    criteriaItem.categories = { ids: categoriesIds };
  }

  if (distributorIds && distributorIds.length > 0) {
    criteriaItem.distributor = { ids: distributorIds };
  }

  if (identifiers && identifiers.length > 0) {
    criteriaItem.instruments = { ids: identifiers };
  }
  return { criteria: [criteriaItem] };
}
